module.exports = __webpack_public_path__ + "static/media/interface.1c4b77a1.png";